// tuning/log.ts (M0-T06, §7.2)
import type { TuningBank } from '../schema/tuning';

export default { chatKeepDays: 7, detailKeepDays: 30 } as const satisfies TuningBank;
